const KNOWN_TERMS = [
  'Abraham Lincoln', 'Adam Smith', 'Akbar', 'Ambedkar', 'Amartya Sen', 'Amitav Ghosh',
  'Aristotle', 'Ashoka', 'Babur', 'B. R. Ambedkar', 'Bal Gangadhar Tilak',
  'Bankim Chandra Chattopadhyay', 'Bhagat Singh', 'Buddha', 'Chanakya',
  'Chandragupta Maurya', 'Chandrashekhar Azad', 'Dadabhai Naoroji', 'David Ricardo',
  'Dr. B. R. Ambedkar', 'Gopal Krishna Gokhale', 'Jawaharlal Nehru', 'Jyotirao Phule',
  'Karl Marx', 'Mahatma Gandhi', 'Maulana Abul Kalam Azad', 'Mangal Pandey',
  'Martin Luther King Jr.', 'Nelson Mandela', 'Muhammad Ali Jinnah', 'Nehru',
  'Rabindranath Tagore', 'Raja Ram Mohan Roy', 'Rani Lakshmibai', 'Rawls',
  'Sardar Patel', 'Sarojini Naidu', 'Savitribai Phule', 'Sher Shah Suri',
  'Subhas Chandra Bose', 'Swami Vivekananda', 'Thomas Malthus', 'Winston Churchill',
  'Gandhi', 'Patel', 'Tagore', 'Periyar', 'Raja Raja Chola', 'Samudragupta',
  'Article 14', 'Article 19', 'Article 21', 'Article 32', 'Article 44', 'Article 51A',
  'Article 72', 'Article 110', 'Article 123', 'Article 143', 'Article 280', 'Article 324',
  'Article 356', 'Article 368', 'Article 370', 'Article 371', 'Article 352',
  'Basic Structure Doctrine', 'Constitution of India', 'Directive Principles of State Policy',
  'Fundamental Duties', 'Fundamental Rights', 'Preamble', 'Right to Equality',
  'Right to Freedom', 'Right to Information', 'Right to Privacy', 'Separation of Powers',
  'Code of Criminal Procedure', 'Indian Penal Code', 'Bharatiya Nyaya Sanhita',
  'Bharatiya Nagarik Suraksha Sanhita', 'Bharatiya Sakshya Adhiniyam',
  'Environment Protection Act', 'Forest Conservation Act', 'Forest Rights Act',
  'National Green Tribunal Act', 'Right to Education Act', 'Right to Information Act',
  'Representation of the People Act', 'Wildlife Protection Act', 'Water Act', 'Air Act',
  'Panchayati Raj', '73rd Amendment', '74th Amendment', 'Goods and Services Tax',
  'Fiscal Responsibility and Budget Management Act', 'Prevention of Money Laundering Act',
  'Scheduled Castes and Scheduled Tribes', 'Protection of Civil Rights Act',
  'Paris Agreement', 'Kyoto Protocol', 'Montreal Protocol', 'Convention on Biological Diversity',
  'United Nations Framework Convention on Climate Change', 'Sustainable Development Goals',
  'Millennium Development Goals', 'Basel Convention', 'Stockholm Convention', 'Ramsar Convention',
  'Vienna Convention', 'Convention on International Trade in Endangered Species',
  'Non-Aligned Movement', 'South Asian Association for Regional Cooperation',
  'Association of Southeast Asian Nations', 'World Trade Organization', 'United Nations',
  'World Health Organization', 'International Monetary Fund', 'World Bank',
  'Nuclear Non-Proliferation Treaty', 'Comprehensive Nuclear-Test-Ban Treaty',
  'Helsinki Accords', 'Universal Declaration of Human Rights',
  'Federalism', 'Secularism', 'Socialism', 'Communalism', 'Globalisation', 'Globalization',
  'Liberalisation', 'Liberalization', 'Privatisation', 'Privatization', 'Sovereignty',
  'Utilitarianism', 'Deontology', 'Consequentialism', 'Virtue Ethics', 'Kantian Ethics',
  'Social Contract', 'Natural Justice', 'Judicial Review', 'Judicial Activism',
  'Judicial Overreach', 'Public Interest Litigation', 'Ordinance', 'Money Bill',
  'No-Confidence Motion', 'Collective Responsibility', 'Coalition Government',
  'Circular Economy', 'Blue Economy', 'Green Economy', 'Carbon Tax', 'Carbon Credit',
  'Carbon Sequestration', 'Human Development Index', 'Gini Coefficient',
  'Purchasing Power Parity', 'Demographic Dividend', 'Phillips Curve', 'Laffer Curve',
  'Keynesian Economics', 'Monetarism', 'Behavioural Economics', 'Behavioral Economics',
  'Comparative Advantage', 'Opportunity Cost', 'Market Failure', 'Tragedy of the Commons',
  'Public Choice Theory', 'Game Theory', 'Malthusian Theory', 'Theory of Evolution',
  'Plate Tectonics', 'Continental Drift', 'Demographic Transition Theory',
  'Heartland Theory', 'Rimland Theory', 'Monsoon Theory', 'Albedo Effect',
  'Greenhouse Effect', 'Ozone Depletion', 'Eutrophication', 'Bioaccumulation',
  'Biomagnification', 'Ecological Succession', 'Keystone Species', 'Invasive Species',
  'Biodiversity Hotspot', 'Food Chain', 'Food Web', 'Trophic Level',
  'Doctrine of Lapse', 'Permanent Settlement', 'Ryotwari System', 'Mahalwari System',
  'Subsidiary Alliance', 'Indian National Congress', 'Quit India Movement',
  'Civil Disobedience Movement', 'Non-Cooperation Movement', 'Swadeshi Movement',
  'Revolt of 1857', 'Battle of Plassey', 'Battle of Buxar', 'Jallianwala Bagh massacre',
  'Government of India Act 1935', 'Government of India Act 1919', 'Regulating Act 1773',
  'Charter Act 1833', 'Indian Councils Act 1909', 'Indian Independence Act 1947',
  'Harappan Civilisation', 'Indus Valley Civilisation', 'Bhakti Movement', 'Sufi Movement',
  'Green Revolution', 'White Revolution', 'Blue Revolution', 'Operation Flood',
  'Narmada Bachao Andolan', 'Chipko Movement', 'Silent Valley Movement',
  'Gandhian Philosophy', 'Buddhist Philosophy', 'Jain Philosophy', 'Advaita Vedanta',
  'Satyagraha', 'Ahimsa', 'Dharma', 'Arthashastra', 'Poverty Line', 'Inflation',
  'Gross Domestic Product', 'Gross National Product', 'Balance of Payments',
  'Current Account Deficit', 'Repo Rate', 'Reverse Repo Rate', 'Monetary Policy',
  'Fiscal Policy', 'Minimum Support Price', 'Public Distribution System',
];

const escapeRegex = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const knownTermsPattern = new RegExp(
  `\\b(?:${KNOWN_TERMS.slice().sort((a, b) => b.length - a.length).map(escapeRegex).join('|')})\\b`,
  'gi',
);
const acronymPattern = /\b[A-Z][A-Z0-9]{1,6}\b/g;
const articlePattern = /\bArticle\s+\d+[A-Z]?\b/gi;
const namedPhrasePattern = /\b(?:(?:The|A|An)\s+)?[A-Z][a-z]+(?:[-'][A-Za-z]+)?(?:\s+(?:(?:of|the|and|for|in|on|to|&)\s+)?[A-Z][a-z]+(?:[-'][A-Za-z]+)?){1,5}\b/g;
const leadingArticlePattern = /^(?:the|a|an)\s+/i;
const romanNumerals = new Set(['II', 'III', 'IV', 'VI', 'VII', 'VIII', 'IX', 'XI', 'XII']);
const nonTerms = new Set(['AND', 'AS', 'AT', 'BUT', 'BY', 'IF', 'IN', 'IS', 'IT', 'MCQ', 'NO', 'NOT', 'OF', 'ON', 'OR', 'PYQ', 'THE', 'TO']);
const phraseStarters = new Set([
  'both', 'choose', 'consider', 'correct', 'following', 'given', 'how', 'important',
  'for', 'indicate', 'select', 'statement', 'statements', 'which', 'why',
]);

export function findImportantTerms(text) {
  if (typeof text !== 'string' || !text) return [];
  const candidates = [];

  const collect = (pattern, namedPhrase = false) => {
    pattern.lastIndex = 0;
    let match = pattern.exec(text);
    while (match) {
      let value = match[0];
      let start = match.index;
      if (namedPhrase) {
        const article = value.match(leadingArticlePattern);
        if (article) {
          value = value.slice(article[0].length);
          start += article[0].length;
        }
        const words = value.split(/\s+/);
        if (words.length < 2 || phraseStarters.has(words[0].toLowerCase())) {
          match = pattern.exec(text);
          continue;
        }
      }
      if (!romanNumerals.has(value) && !nonTerms.has(value)) {
        candidates.push({ text: value, start, end: start + value.length });
      }
      match = pattern.exec(text);
    }
  };

  collect(knownTermsPattern);
  collect(articlePattern);
  collect(acronymPattern);
  collect(namedPhrasePattern, true);

  candidates.sort((a, b) => a.start - b.start || (b.end - b.start) - (a.end - a.start));
  const selected = [];
  let end = -1;
  for (const candidate of candidates) {
    if (candidate.start < end) continue;
    selected.push(candidate);
    end = candidate.end;
  }
  return selected;
}

export function matchTermsInText(text, terms) {
  if (typeof text !== 'string' || !text || !Array.isArray(terms)) return [];
  const candidates = [];
  terms.forEach(term => {
    if (!term || typeof term.text !== 'string' || !term.text.trim()) return;
    const escaped = term.text.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(`\\b${escaped}\\b`, 'gi');
    let match = pattern.exec(text);
    while (match) {
      candidates.push({
        ...term,
        text: match[0],
        start: match.index,
        end: match.index + match[0].length,
      });
      match = pattern.exec(text);
    }
  });
  candidates.sort((a, b) => a.start - b.start || (b.end - b.start) - (a.end - a.start));
  const selected = [];
  let end = -1;
  for (const candidate of candidates) {
    if (candidate.start < end) continue;
    selected.push(candidate);
    end = candidate.end;
  }
  return selected;
}

export const wikipediaSearchUrl = term =>
  `https://en.wikipedia.org/w/index.php?search=${encodeURIComponent(term)}&go=Go`;
